<template>
	<ul class="menu-nav">
		<li
			aria-haspopup="true"
			data-menu-toggle="hover"
			class="menu-item item"
			:class="(selectId === item.id)&& 'menu-item-active'"
			v-for="item in menu"
			:key="item.id"
		>
			<span class="menu-link" @click="navigate(item)">
				<span class="menu-text">{{item.clientName}}</span>
			</span>
		</li>
	</ul>
</template>

<script>
	import { mapState } from "vuex";
	import { addLeftMenu } from "@/util/index.js";
	export default {
		name: "KTMenu",
		watch: {
			menu() {
				this.selectIdInit();
			},
		},
		data() {
			return {
				isActive: "menu-item-active",
				selectId: "",
			};
		},
		created() {
			this.selectIdInit();
		},
		methods: {
			selectIdInit() {
				if (this.menu[0]) {
					this.selectId = this.menu[0].id;
				}
			},
			navigate(item) {
				if (this.selectId === item.id) {
					return;
				}
				addLeftMenu(item.clientId, (routers, leftMenus) => {
					this.$nextTick(() => {
						this.$router.addRoutes(routers);
						this.$router.push(
							`${
								leftMenus[0].children
									? `/${leftMenus[0].path}/leftMenus[0].children[0].path`
									: leftMenus[0].path
							}`
						);
					});
				});
			},
			hasActiveChildren(match) {
				return this.$route["path"].indexOf(match) !== -1;
			},
		},
		computed: {
			...mapState({
				menu: (state) => state.auth.headerMenus,
			}),
		},
	};
</script>
